
export default function Hero() {
  return (
    <section id="home" className="relative h-screen flex items-center justify-center overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/fa219add28f0cad9039516dadd673d24.jpg')`
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-[#1E3A5F]/95 via-[#1E3A5F]/85 to-transparent"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="max-w-3xl">
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
            REDA & NAOUAL
          </h1>
          <p className="text-3xl md:text-4xl text-[#A83232] font-semibold mb-4">
            Art du Métal
          </p>
          <p className="text-xl md:text-2xl text-white mb-8 leading-relaxed">
            Plus de 20 ans d'excellence dans la fabrication de solutions métalliques sur mesure
          </p>
          <div className="flex flex-wrap gap-4">
            <a 
              href="#products" 
              className="bg-[#A83232] text-white px-8 py-4 rounded-lg font-semibold hover:bg-[#8A2828] transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              Découvrir nos produits
            </a>
            <a 
              href="#contact" 
              className="bg-white text-[#1E3A5F] px-8 py-4 rounded-lg font-semibold hover:bg-gray-100 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              Nous contacter
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-4xl"></i>
      </div>
    </section>
  );
}
